module.exports = "/shifts/components/salesEditComponent-d48af5.html";